/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Help_CenterInputs */

const en_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help Center`)
};

const id_nav_help_center = /** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pusat Bantuan`)
};

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const es_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const fr_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const de_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const ja_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const zh_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const ar_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const it_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const ru_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const pt_nav_help_center = en_nav_help_center;

/** @type {(inputs: Nav_Help_CenterInputs) => LocalizedString} */
const ko_nav_help_center = en_nav_help_center;

/**
* | output |
* | --- |
* | "Help Center" |
*
* @param {Nav_Help_CenterInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_help_center = /** @type {((inputs?: Nav_Help_CenterInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Help_CenterInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_help_center(inputs)
	if (locale === "es") return es_nav_help_center(inputs)
	if (locale === "fr") return fr_nav_help_center(inputs)
	if (locale === "de") return de_nav_help_center(inputs)
	if (locale === "ja") return ja_nav_help_center(inputs)
	if (locale === "zh") return zh_nav_help_center(inputs)
	if (locale === "ar") return ar_nav_help_center(inputs)
	if (locale === "id") return id_nav_help_center(inputs)
	if (locale === "it") return it_nav_help_center(inputs)
	if (locale === "ru") return ru_nav_help_center(inputs)
	if (locale === "pt") return pt_nav_help_center(inputs)
	return ko_nav_help_center(inputs)
});